import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postJwtLogin,
} from "../../../helpers/auth_helper";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  console.log("Starting login saga for:", user.email);

  // Log all REACT_APP env vars for debugging
  const reactAppEnvs = Object.keys(process.env).filter(key => key.startsWith('REACT_APP_'));
  console.log("Available REACT_APP env vars:", reactAppEnvs);

  let authMode = (process.env.REACT_APP_DEFAULTAUTH || "").trim().toLowerCase();

  if (!authMode) {
    console.warn("REACT_APP_DEFAULTAUTH is not defined in environment variables. Falling back to 'jwt'.");
    authMode = "jwt";
  }

  console.log("Current AUTH mode (normalized):", `[${authMode}]`);

  try {
    if (authMode === "firebase") {
      console.log("Using Firebase authentication");
      const response = yield call(
        fireBaseBackend.loginUser,
        user.email,
        user.password
      );
      yield put(loginSuccess(response));
    } else if (authMode === "jwt") {
      console.log("Using JWT authentication. Calling postJwtLogin...");
      const response = yield call(postJwtLogin, user)
      console.log("Login response received:", response);

      if (response && (response.token || response.accessToken)) {
        localStorage.setItem("authUser", JSON.stringify(response));
        yield put(loginSuccess(response));
        console.log("Auth successful, stored in localStorage");
      } else {
        console.warn("Login response missing token:", response);
        throw new Error("Invalid response from server: Token missing");
      }
    } else if (authMode === "fake") {
      console.log("Using Fake authentication");
      const response = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      });
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    } else {
      console.warn("No matching AUTH mode found for:", authMode);
      // Fallback or error?
    }

    if (localStorage.getItem("authUser")) {
      console.log("Navigating to dashboard...");
      if (typeof history === 'function') {
        history('/dashboard');
      } else if (history && typeof history.push === 'function') {
        history.push('/dashboard');
      } else {
        console.error("History object is not valid for navigation", history);
        // Fallback navigation
        window.location.href = "/dashboard";
      }
    } else {
      console.error("Not navigating: authUser not found in localStorage");
    }

  } catch (error) {
    console.error("Login saga error:", error);
    yield put(apiError(error.message || error));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    }
    else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      yield put(logoutUserSuccess());
    }
    history('/login');
  } catch (error) {
    yield put(apiError(error));
  }
}

function* socialLogin({ payload: { type, history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      const response = yield call(fireBaseBackend.socialLoginUser, type);
      if (response) {
        history("/dashboard");
      } else {
        history("/login");
      }
      localStorage.setItem("authUser", JSON.stringify(response));
      yield put(loginSuccess(response));
    }
    if (response)
      history("/dashboard");
  } catch (error) {
    yield put(apiError(error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeLatest(SOCIAL_LOGIN, socialLogin);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
